export default [
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: () => import('@/views/account/password-change'),
    hidden: true,
    meta: {
      title: '修改密码',
    },
    children: [],
  },
];
